<template lang="pug">
  #MotorAkkuk.roll: .app
    vue-headful(title="Motorkerékpár Akkuk - Forex kft.")
    .block
      .page-title Motorkerékpár akku-kereső
    .kereso.content-block.block.loading-block(:class='{"is-loading": form.loading}')
        form.form-mezok(@submit.prevent='submit()')
          FormMezo(v-for='mezo in form.mezok', :mezo='mezo', :model='model', :class="mezo.id")
    .lista.content-block.content(v-if='link_valid')
      .title.is-6 Akkumulátorok:
      div(v-for='accu in this.akkuk')
        a(v-if='accu.Url.length > 0', :href='accu.Url' target='_blank'): b {{ accu.Típus }}
        span.gray(v-else) {{ accu.Típus }}
</template>

<script>

import {MotorAkkuModel} from '../akkuk/MotorAkkuk.js'
import FormMezo from '../form/FormMezo.vue'
import {MotorAkkuService} from "./MotorAkkuService.js";

export default {
  data: () => ({
    model: MotorAkkuModel.create(),
    form: MotorAkkuModel.form({}),
    link_valid: false,
    akkuk: '',
  }),
  components: { FormMezo },
  name: "MotorAkkuk",
  created() {
    this.service = new MotorAkkuService(this.model);
    this.$watch(function() { return this.model.Gyártmány; }, this.GetModellek);
    this.$watch(function() { return this.model.Modell; }, this.GetCcmek);
    this.$watch(function() { return this.model.Ccm; }, this.GetTípusok);
    this.$watch(function() { return this.model.Típus; }, this.GetLinkek);
    this.GetGyártmányok();
  },

  methods: {
    async submit()
    {
    },
    async GetGyártmányok()
    {
        var placeholder = this.form.mezok[0].options[0];
        this.model.Gyártmány = placeholder;
        var options = await this.service.SendGetGyártmányok();
        options.unshift(placeholder);
        this.form.mezok[0].options = options;
    },
    async GetModellek()
    {
        var placeholder = this.form.mezok[1].options[0];
        this.model.Modell = placeholder;
        var options = [];
        if (this.model.Gyártmány != null && !this.model.Gyártmány.startsWith("-"))
            options = await this.service.SendGetModellek();
        options.unshift(placeholder);
        this.form.mezok[1].options = options;
    },
    async GetCcmek()
    {
        var placeholder = this.form.mezok[2].options[0];
        this.model.Ccm = placeholder;
        var options = [];
        if (this.model.Modell != null && !this.model.Modell.startsWith("-"))
            options = await this.service.SendGetCcmek();
        options.unshift(placeholder);
        this.form.mezok[2].options = options;
    },
    async GetTípusok()
    {
        var placeholder = this.form.mezok[3].options[0];
        this.model.Típus = placeholder;
        var options = [];
        if (this.model.Ccm != null && !this.model.Ccm.startsWith("-"))
            options = await this.service.SendGetTípusok();
        options.unshift(placeholder);
        this.form.mezok[3].options = options;
    },
    async GetLinkek()
    {
        this.link_valid = false;
        if (this.model.Típus == null || this.model.Típus.startsWith("-"))
            return;
        this.akkuk = await this.service.SendGetLinkek();
        this.akkuk = this.akkuk.sort(this.CompareLinks);
        this.link_valid = true;
    },

    CompareLinks(a, b) {
      if (a.Url.length != 0 ^ b.Url.length != 0) {
        return a.Url < b.Url ? 1 : -1;
      }
      if (a.Típus == b.Típus) return 0;
      return a.Típus < b.Típus ? -1 : 1;
    }
  },
}
</script>

<style lang='sass'>
$primary: #1846ec
$link-hover: #E92539

@import "../app/main.sass"

#MotorAkkuk
  max-width: 80rem
  padding: 1rem
  overflow: auto
  margin: 0 auto
.app
  width: 100%
  margin: auto

body
  background: url('./Motorok.jpg') no-repeat center center
  background-size: cover

.input, .select
  border-radius: 1px
  border-color: #fff
  box-shadow: none
  &:focus
    box-shadow: 0 0 0 2px $primary

.content-block
  background: #fff
  box-shadow: 0 0 5px 0 rgba(#22243b, .7)

  padding: 1rem
+desktop
  .form-mezok
    display: flex
    flex-wrap: wrap

    .FormMezo
      &:not(:last-child)
        padding-right: .5rem
      flex: 0 0 auto
      &.Gyártmány, &.Típus
        flex-basis: 35%
      &.Ccm, &.Modell
        flex-basis: 15%

.label
  /*color: #fff*/
  /*background: rgba(#fff, .95)*/
  /*padding: .2em .4em*/
  display: inline-block
.control
  font-size: 1.2rem
.lista
  background: #fff
  transition: all .4s

.page-title
  background: #ED1C24
.logo
  flex: 1
#logo
  height: 100%

.FormMezo a
  text-decoration: underline


.error
  margin: 1rem 0
.bold
  font-weight: bold
.gray
  color: #C0C0C0
</style>
